import { ensureBundledocsActionCompleted } from './ensureBundledocsActionCompleted'
import { useDocumentBundleWizardStore } from '@repo/store/useDocumentBundleWizardStore'

export const addBundleToMatterHistory = async (bundleData: any) => {
  await ensureBundledocsActionCompleted(bundleData, (suppressErrorToast: boolean) =>
    useDocumentBundleWizardStore.getState().addBundleToMatterHistory({
      matterBundleId: bundleData?.matterBundleId,
      suppressErrorToast
    })
  )
}
